import type { AllRouteEndpoints } from "../routeTypes";
export const apiUsageAlertUpsertCacheKeys: AllRouteEndpoints[] = [
  "/api_usage_alert/upsert",
  "/api_usage_alert/:alert_id",
];
